<div
  [filePond]="{
    maxFiles: maxFiles,
    allowMultiple: allowMultiple,
    acceptedFileTypes: acceptedFileTypes,
    allowSyncAcceptAttribute: true,
    onaddfile: onAddFile,
    onremovefile: onRemoveFile,
    instantUpload: instantUpload,
    allowFileSizeValidation: allowFileSizeValidation,
    maxFileSize: maxFileSize,
    maxTotalFileSize: maxTotalFileSize,
    server: {
      process: onProcessFile
    },
    labelIdle:
      labelIdle ||
        'Trascina e rilascia il referto dello studio o <span class=\'filepond--label-action\'> clicca qui </span> per selezionarli'
      | transloco
  }"
  [filePondInitialFiles]="attachments"
  [disablePaste]="true"
  class="flex flex-1 rounded-md border-2 border-dashed border-slate-100"
>
  <div class="flex flex flex-1 flex-col items-center justify-center gap-2">
    <i class="fa-light fa-cloud-arrow-up fa-3x text-slate-300"></i>
    <span class="text-base text-slate-400">
      {{ "Trascina o clicca per selezionare un file" | transloco }}
    </span>
  </div>
</div>
